<template>
  <div class="md-card md-card-profile">
    <div class="md-card-avatar">
      <img class="img" :src="cardUserImage" />
    </div>

    <div class="md-card-content">
      <h6 class="category text-gray">CEO / Co-Founder</h6>
      <h4 class="card-title">Alec Thompson</h4>
      <p class="card-description">
        Don't be scared of the truth because we need to restart the human
        foundation in truth And I love you like Kanye loves Kanye I love Rick
        Owens' bed design but the back is...
      </p>
      <button class="md-button md-round" :class="getColorButton(buttonColor)"
        >Follow</button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "user-card",
  props: {
    cardUserImage: {
      type: String,
      default: "/img/faces/marc.jpg",
    },
    buttonColor: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    getColorButton: function (buttonColor) {
      return "md-" + buttonColor + "";
    },
  },
};
</script>
<style></style>
